// src/pages/RecordingPage.tsx
import React, { useState } from 'react';
import AudioRecorder from '../components/AudioRecorder/AudioRecorder';
import WaveformVisualizer from '../components/WaveformVisualizer/WaveFormVisualizer'
import ProcessingStatus from '../components/ProcessingStatus/processingStatus';
import { Button } from '../components/ui/button';

const RecordingPage: React.FC = () => {
  const [audioBlob, setAudioBlob] = useState<Blob | null>(null);
  const [audioUrl, setAudioUrl] = useState<string>('');
  const [processingStatus, setProcessingStatus] = useState<'PENDING' | 'PROCESSING' | 'COMPLETED' | 'FAILED' | 'CANCELLED'>('PENDING');
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState<string>('');
  const [stats, setStats] = useState<{
    fillerWordsRemoved: number;
    processingTime: number;
    outputFileSize: number;
  } | null>(null);

  const handleRecordingComplete = (blob: Blob) => {
    setAudioBlob(blob);
    setAudioUrl(URL.createObjectURL(blob));
  };

  const handleProcessing = async () => {
    if (!audioBlob) return;

    setProcessingStatus('PROCESSING');
    
    try {
      const formData = new FormData();
      formData.append('audio', audioBlob);

      // Simulate processing with progress updates
      for (let i = 0; i <= 100; i += 10) {
        await new Promise(resolve => setTimeout(resolve, 500));
        setProgress(i); 
      }

      // TODO: Replace with actual API call
      // const response = await fetch('/api/process-audio', {
      //   method: 'POST',
      //   body: formData,
      // });

      setProcessingStatus('COMPLETED');
      setStats({
        fillerWordsRemoved: 15,
        processingTime: 3.5,
        outputFileSize: 2.4
      });
    } catch (err) {
      setProcessingStatus('FAILED');
      setError('Failed to process audio');
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-8">
      <h1 className="text-3xl font-bold text-center mb-8">
        Voice Filter App
      </h1>

      <AudioRecorder
        onRecordingComplete={handleRecordingComplete}
        onError={setError}
      />

      {audioUrl && (
        <div className="space-y-4">
          <WaveformVisualizer audioUrl={audioUrl} />
          
          <div className="flex justify-center">
            <Button
              onClick={handleProcessing}
              disabled={processingStatus === 'PROCESSING'}
              className="w-full max-w-md"
            >
              Process Recording
            </Button>
          </div>

          <ProcessingStatus
            status={processingStatus}
            progress={progress}
            error={error}
            stats={stats ?? undefined}
          />
        </div>
      )}
    </div>
  );
};

export default RecordingPage;